"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselLoader = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const CarouselComponents_1 = require("./CarouselComponents");
const Skeleton_1 = require("../Skeleton");
const CarouselItemPadding = (0, app_1.styled)(CarouselComponents_1.CarouselItem) `
  padding: ${(theme) => theme.spacing.small};
`;
function CarouselLoader({ frames = 1, }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Array.from({ length: frames }).map((_v, index) => ((0, jsx_runtime_1.jsx)(CarouselComponents_1.Frame, Object.assign({ "data-type": "frame" }, { children: (0, jsx_runtime_1.jsx)(CarouselItemPadding, { children: (0, jsx_runtime_1.jsx)(Skeleton_1.SkeletonBox, {}) }) }), index))) }));
}
exports.CarouselLoader = CarouselLoader;
